export const LOGIN_USER_START = 'login_user_start';
export const LOGIN_USER_SUCCESS = 'login_user_success';
export const LOGIN_USER_FAIL = 'login_user_fail';
export const FETCH_TOKEN = 'fetch_token';
export const LOAD_FETCHING = 'load_fetching';
export const LOAD_GET_DATA = 'load_get_data';
export const GET_DATA_START = 'get_data_start';
export const GET_DATA_SUCCESS = 'get_data_success';
export const GET_DATA_FAIL = 'get_data_fail';
export const GET_QUARTER_DATA_SUCCESS = 'get_quarter_data_success';
export const GET_QUARTER_DATA_START = 'get_quarter_data_starts';
export const GET_QUARTER_CHART_START = 'get_quarter_chart_start';
export const GET_QUARTER_CHART_SUCCESS = 'get_quarter_chart_success';
export const GET_QUARTER_DSP_CHART_START = 'get_quarter_dsp_chart_start';
export const GET_QUARTER_DSP_CHART_SUCCESS = 'get_quarter_dsp_chart_success';
export const GET_QUARTER_TERRITORY_CHART_START = 'get_quarter_territory_chart_start';
export const GET_QUARTER_TERRITORY_CHART_SUCCESS = 'get_quarter_territory_chart_success';
export const GET_ASSET_PROFILE_START = 'get_asset_profile_start';
export const GET_ASSET_PROFILE_SUCCESS = 'get_asset_profile_success';
export const GET_TOPS_QUARTER_START = 'get_tops_quarter_start';
export const GET_TOPS_QUARTER_SUCCESS = 'get_tops_quarter_success';
export const FORGOT_PASSWORD_SENT = 'forgot_password_sent';
export const CHANGE_PASSWORD_SUCCEESS = 'change_password_success';
export const RESET_PASSWORD_SUCCEESS = 'reset_password_success';
export const GET_FIRST_LOGIN_INFO = 'get_first_login_info';
export const LOGOUT_USER = 'logout_user';
export const RESET_PASSWORD_FAIL = 'reset_password_fail';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_START = 'get_quarter_territory_chart_streams_start';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS = 'get_quarter_territory_chart_streams_sucess';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START = 'get_quarter_territory_chart_downloads_start';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS = 'get_quarter_territory_chart_downloads_sucess';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START = 'get_quarter_territory_chart_streams_isrc_start';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS = 'get_quarter_territory_chart_streams_isrc_sucess';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START = 'get_quarter_territory_chart_downloads_isrc_start';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS = 'get_quarter_territory_chart_downloads_isrc_sucess';
export const GET_ISRC_DSP_CHART_START = 'get_isrc_dsp_chart_start';
export const GET_ISRC_DSP_CHART_SUCESS = 'get_isrc_dsp_chart_success';
export const GET_ISRC_CHART_DATE_START = 'get_isrc_chart_date_start';
export const GET_ISRC_CHART_DATE_SUCESS = 'get_isrc_chart_date_sucess';
export const GET_QUARTER_ACTIVITY_CHART_START = 'GET_QUARTER_ACTIVITY_CHART_START';
export const GET_QUARTER_ACTIVITY_CHART_SUCCESS = 'GET_QUARTER_ACTIVITY_CHART_SUCCESS';
export const GET_IMPERSONATION_LIST_START = "GET_IMPERSONATION_LIST_START";
export const GET_IMPERSONATION_LIST_SUCCESS = "GET_IMPERSONATION_LIST_SUCCESS";
export const SET_IMPERSONATION_LIST_START = "SET_IMPERSONATION_LIST_START";
export const SET_IMPERSONATION_LIST_SUCCESS = "SET_IMPERSONATION_LIST_SUCCESS";
export const GET_LIVE_CHART_DATE_START = "GET_LIVE_CHART_DATE_START";
export const GET_LIVE_CHART_DATE_SUCESS = "GET_LIVE_CHART_DATE_SUCESS";
export const GET_LIVE_DATA_ISRC = "GET_LIVE_DATA_ISRC";
export const GET_LIVE_DATA_ISRC_SUCCESS = "GET_LIVE_DATA_ISRC_SUCCESS";
export const SET_UNIT_TYPE = "SET_UNIT_TYPE";
export const GET_CURRENT_RECIPIENT = "GET_CURRENT_RECIPIENT";
export const GET_CURRENT_RECIPIENT_SUCCESS = "GET_CURRENT_RECIPIENT_SUCCESS";
//SET_LOGIN_START,
//    SET_LOGIN_SUCCESS,
export const SET_LOGIN_START = "SET_LOGIN_START";
export const SET_LOGIN_SUCCESS = "SET_LOGIN_SUCCESS";
export const SET_EMAIL_START = "SET_EMAIL_START";
export const SET_EMAIL_SUCCESS = "SET_EMAIL_SUCCES";

export const GET_GROWTH_CHART = "GET_GROWTH_CHART";
export const GET_GROWTH_CHART_SUCCESS = "GET_GROWTH_CHART_SUCCESS";
export const SET_AUDIOURL = "SET_AUDIOURL";

export const GET_PRODUCT_PROFILE_START = "GET_PRODUCT_PROFILE_START";
export const GET_PRODUCT_PROFILE_SUCCESS = "GET_PRODUCT_PROFILE_SUCCESS";

//GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_START,
//    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_SUCESS,
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_START = "GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_START";
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_SUCESS = "GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_SUCESS";

//GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_START,
//    GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_SUCESS,
export const GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_START = "GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_START";
export const GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_SUCESS = "GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_SUCESS";
//GET_UPC_DSP_CHART_START,
//    GET_UPC_DSP_CHART_SUCESS,
export const GET_UPC_DSP_CHART_START = "GET_UPC_DSP_CHART_START";
export const GET_UPC_DSP_CHART_SUCESS = "GET_UPC_DSP_CHART_SUCESS";
//GET_UPC_CHART_DATE_START,
//    GET_UPC_CHART_DATE_SUCESS,
export const GET_UPC_CHART_DATE_START = "GET_UPC_CHART_DATE_START";
export const GET_UPC_CHART_DATE_SUCESS = "GET_UPC_CHART_DATE_SUCESS";
export const GET_ASSETS_FROM_UPC_START = "GET_ASSETS_FROM_UPC_START";
export const GET_ASSETS_FROM_UPC_SUCESS = "GET_ASSETS_FROM_UPC_SUCESS";
export const GET_PRODUCTS_FROM_ISRC_START = "GET_PRODUCTS_FROM_ISRC_START";
export const GET_PRODUCTS_FROM_ISRC_SUCESS = "GET_PRODUCTS_FROM_ISRC_SUCESS";
//GET_TOPS_MONTH,
//    GET_TOPS_MONTH_SUCCESS,

export const GET_TOPS_MONTH = "GET_TOPS_MONTH";
export const GET_TOPS_MONTH_SUCCESS = "GET_TOPS_MONTH_SUCCESS";

//GET_CATALOGUE_PROFILE_START,
    //GET_CATALOGUE_PROFILE_SUCCESS
export const GET_CATALOGUE_PROFILE_START = "GET_CATALOGUE_PROFILE_START";
export const GET_CATALOGUE_PROFILE_SUCCESS = "GET_CATALOGUE_PROFILE_SUCCESS";

//GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_START,
//    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_SUCESS,
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_START = "GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_START";
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_SUCESS = "GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_SUCESS";

//GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_START,
//    GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_SUCESS,
export const GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_START = "GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_START";
export const GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_SUCESS = "GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_SUCESS";
//GET_CATALOGUE_DSP_CHART_START,
//    GET_CATALOGUE_DSP_CHART_SUCESS,
export const GET_CATALOGUE_DSP_CHART_START = "GET_CATALOGUE_DSP_CHART_START";
export const GET_CATALOGUE_DSP_CHART_SUCESS = "GET_CATALOGUE_DSP_CHART_SUCESS";
//GET_CATALOGUE_CHART_DATE_START,
//    GET_CATALOGUE_CHART_DATE_SUCESS,
export const GET_CATALOGUE_CHART_DATE_START = "GET_CATALOGUE_CHART_DATE_START";
export const GET_CATALOGUE_CHART_DATE_SUCESS = "GET_CATALOGUE_CHART_DATE_SUCESS";
export const GET_ASSETS_FROM_CATALOGUE_START = "GET_ASSETS_FROM_CATALOGUE_START";
export const GET_ASSETS_FROM_CATALOGUE_SUCESS = "GET_ASSETS_FROM_CATALOGUE_SUCESS";
//GET_CATALOGUES_START,
//    GET_CATALOGUES_SUCCESS,
export const GET_CATALOGUES_START = "GET_CATALOGUES_START";
export const GET_CATALOGUES_SUCCESS = "GET_CATALOGUES_SUCCESS";
//    GET_CATALOGUES_SUCCESS,
export const GET_PRODUCTS_START = "GET_PRODUCTS_START";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
//GET_PRODUCT_TOTALS,
//    GET_PRODUCT_TOTALS_SUCCESS,
export const GET_PRODUCT_TOTALS = "GET_PRODUCT_TOTALS";
export const GET_PRODUCT_TOTALS_SUCCESS = "GET_PRODUCT_TOTALS_SUCCESS";
export const GET_ASSET_TOTALS = "GET_ASSET_TOTALS";
export const GET_ASSET_TOTALS_SUCCESS = "GET_ASSET_TOTALS_SUCCESS";
export const GET_CATALOGUE_TOTALS = "GET_CATALOGUE_TOTALS";
export const GET_CATALOGUE_TOTALS_SUCCESS = "GET_CATALOGUE_TOTALS_SUCCESS";
export const SET_ARTIST_SEARCH = "SET_ARTIST_SEARCH";
export const SET_TITLE_SEARCH = "SET_TITLE_SEARCH";
//GET_CATALOGUES_SEARCH_START,
//    GET_CATALOGUES_SEARCH_SUCCESS,
//    GET_GENRES_START,
//    GET_GENRES_SUCCESS,
export const GET_CATALOGUES_SEARCH_START = "GET_CATALOGUES_SEARCH_START";
export const GET_CATALOGUES_SEARCH_SUCCESS = "GET_CATALOGUES_SEARCH_SUCCESS";
export const GET_GENRES_START = "GET_GENRES_START";
export const GET_GENRES_SUCCESS = "GET_GENRES_SUCCESS";
//#  SET_GENRES_SEARCH,
//    SET_CATALOGUES_SEARCH
export const SET_GENRES_SEARCH = "SET_GENRES_SEARCH";
export const SET_CATALOGUES_SEARCH = "SET_CATALOGUES_SEARCH";
export const SET_ISRC_SEARCH = "SET_ISRC_SEARCH";
//GET_SEARCH_DATA,
//    GET_SEARCH_SUCCESS,
export const GET_SEARCH_DATA = "GET_SEARCH_DATA";
export const GET_SEARCH_SUCCESS = "GET_SEARCH_SUCCESS";


// WEBPACK FOOTER //
// ./src/store/Types.js